// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__nBK39","inner":"style_inner__ccJ3i","bottom":"style_bottom__rgeLG","copyright":"style_copyright__13Z6C"};